import { render, staticRenderFns } from "./KycModal.vue?vue&type=template&id=71194b9e"
import script from "./KycModal.vue?vue&type=script&lang=js"
export * from "./KycModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports